import { useMemo } from 'react';

import { PERSONALISED_PRICE, PRICE } from '~/utilities/constants/algolia';
import { useUserContext } from '~/utilities/context/dynamic/UserContext';
import { useAppContext } from '~/utilities/context/static/AppContext';
import { useProductListContext } from '~/utilities/context/static/ProductListContext';
import { useStaticContext } from '~/utilities/context/static/StaticContext';
import { getHiddenDiscountFacet } from '~/utilities/helpers/getHiddenDiscountFacet';

export const useAlgoliaFacets = () => {
  const {
    configuration: { membersOnlyPriceEnabled, l30DPricesEnabled },
  } = useStaticContext();
  const { visibleFacetsList, categoryDetails: { visibleFacetsV2 } = {} } = useProductListContext();
  const { lang } = useAppContext();
  const { loggedInCookie } = useUserContext();
  const membersOnlyFeature = membersOnlyPriceEnabled && loggedInCookie;

  const result = useMemo(() => {
    const hiddenDiscountFacet = getHiddenDiscountFacet(l30DPricesEnabled, visibleFacetsList);

    return (visibleFacetsV2 || [])
      .filter(facet => facet && facet.code !== hiddenDiscountFacet)
      .map(facet => {
        const shouldUsePersonalisedPrice = membersOnlyFeature && facet.code === PRICE;
        const actualAttribute = shouldUsePersonalisedPrice ? PERSONALISED_PRICE : facet.code;

        return {
          attribute: facet.localized ? `${actualAttribute}.${lang}` : `${actualAttribute}`,
          // SAP CX does not always return a display name, fall back to the code
          text: facet.name ?? facet.code,
          valueEN: facet.code,
        };
      });
  }, [l30DPricesEnabled, lang, membersOnlyFeature, visibleFacetsList, visibleFacetsV2]);

  return result;
};
